export default __webpack_public_path__ + "static/media/roles_4.92dbb2cf.png";